var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';








const Pill = ({ children, color = 'gray', className }) => {
  let pillColors = '';

  switch (color) {
    case 'gray':
      pillColors = 'bg-gray-100';
      break;

    case 'yellow':
      pillColors = 'bg-yellow-100 text-yellow-800';
      break;
    case 'green':
      pillColors = 'bg-green-100 text-green-800';
      break;
    case 'blue':
      pillColors = 'bg-blue-100 text-blue-800';
      break;
    case 'red':
      pillColors = 'bg-red-100 text-red-800';
      break;

    default:
      pillColors = 'bg-primary-100 text-primary-800';
      break;
  }
  return (/*#__PURE__*/
    _jsx("span", {
      className: `${className} ${pillColors} px-2.5 py-1 rounded-md text-xs `,
      "data-testid": "pill-comp" }, void 0,

    children
    ));

};


export { Pill };